import { AxiosRequestBuilder } from '../../../services/axiosRequestBuilder';
import { StatusRespostaPesquisa } from '../../questionnaire/types/questionnaire.types';
import { Escolas, Event, InglesParanaKids } from '../types/events.types';

export const eventService = {
  // buscarEventos: async (
  //   eventUIds: string,
  //   signal?: AbortSignal
  // ): Promise<Event[]> => {
  //   const axiosRequestBuilder = new AxiosRequestBuilder();
  //   const { data } = await axiosRequestBuilder
  //     .setMethod('get')
  //     .setUrl(`Workshop/GetEvents/${eventUIds}`)
  //     .setResponseType('json')
  //     .setSignal(signal)
  //     .send<Event[]>();

  //   return data;
  // },

  buscarEventos: async (
    eventUIds: string,
    signal?: AbortSignal
  ): Promise<Event[]> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('post')
      .setUrl(`Workshop/GetEvents`)
      .setBody(eventUIds.split(','))
      .setResponseType('json')
      .setSignal(signal)
      .send<Event[]>();

    return data;
  },

  buscarEscolas: async (signal?: AbortSignal): Promise<Escolas[]> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl(`Pesquisa/Escolas`)
      .setResponseType('json')
      .setSignal(signal)
      .send<Escolas[]>();

    return data;
  },

  buscarDadosEstudanteInglesParanaKids: async (
    signal?: AbortSignal
  ): Promise<InglesParanaKids> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl(`Pesquisa/get-user-ingles-parana-kids`)
      .setResponseType('json')
      .setSignal(signal)
      .send<InglesParanaKids>();

    return data;
  },

  getStatusPesquisa: async (
    signal?: AbortSignal
  ): Promise<StatusRespostaPesquisa> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl('/Pesquisa/GetStatusPesquisaByUser')
      .setResponseType('json')
      .setSignal(signal)
      .send<StatusRespostaPesquisa>();

    return data;
  },
};
